import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useTheme } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickComponentCommonProps, pickDataProps, pickAriaProps, } from "../../interfaces/commonProps.mjs.mjs";
import { StyledIcon, StyledIconWrapper, StyledSVG } from "./Icon.styles.mjs.mjs";
import { iconMapping } from "./iconMapping.mjs.mjs";
import { iconsNames } from "./IconsNames.mjs.mjs";
const sizeDimensions = {
    l: 48,
    s: 24,
    xs: 16,
};
const sizeMapping = {
    large: 'l',
    small: 's',
    xs: 'xs',
    s: 's',
    l: 'l',
};
export const Icon = React.forwardRef(({ ...restProps }, ref) => {
    const commonProps = pickComponentCommonProps(restProps);
    const { size, name } = restProps;
    const iconBasePath = useTheme().iconBasePath;
    const outerSpacing = useSpacing(restProps);
    const dataProps = pickDataProps(restProps);
    const ariaProps = pickAriaProps(restProps);
    if (iconBasePath) {
        /* Mapping gets relevant as soon as iconBasePath is defined.
         * For the <Icon /> component to be NOT BREAKING we still need to
         * allow the icon names from version 3 of the icon library. Those
         * will get mapped to the new version 4 names. Same goes for the
         * icon sizes */
        const mappedSize = sizeMapping[size];
        const mappedSizeDimension = sizeDimensions[mappedSize];
        const mappedIconNames = iconMapping[name] ? iconMapping[name] : name;
        const cleanedBasePath = iconBasePath === null || iconBasePath === void 0 ? void 0 : iconBasePath.replace(/\/$/, '');
        const svgUrl = `${cleanedBasePath}/${mappedIconNames}-${mappedSize}.svg#main`;
        return (React.createElement(StyledSVG, { variant: restProps.variant, width: mappedSizeDimension, height: mappedSizeDimension, fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": true, ...ariaProps, "data-testid": restProps['data-testid'], outerSpacing: outerSpacing, ref: ref, className: restProps.className },
            React.createElement("use", { href: svgUrl })));
    }
    /**
     * If there is no iconBasePath being provided but a user of <Icon /> uses a new icon name,
     * we render a default error/missing icon. That is why isLegacyIconName checks if its an name
     * that is also used in the legacy icon font. We do not need to check for size because if name fails
     * size check is not relevant.
     * */
    const isLegacyIconName = iconsNames.includes(name);
    if (isLegacyIconName) {
        return (React.createElement(StyledIconWrapper, { ...restProps, ...dataProps, ...ariaProps, ...commonProps, variant: restProps.variant, outerSpacing: outerSpacing, "aria-hidden": true, ref: ref },
            React.createElement(StyledIcon, { className: `aui-icon-${name}-${size}` })));
    }
    console.warn(`"${name}" is an non legacy icon name while no IconBaseUrlContext was provided.`);
    // Show error icon if a new icon name is used but no context svg icons available
    return (React.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { width: "22", height: "22", fill: "white", stroke: "#333333", strokeWidth: "2", x: "1", y: "1" })));
});
Icon.displayName = 'Icon';
//# sourceMappingURL=Icon.mjs.mjs.map